import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Alert, AlertTitle } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    paper: {
        margin: '1em',
        overflow: "scroll",
        width: "100%",
        height: "90%",
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));

export default function InfoItems({infoCollection, itemSteps, activatedButton, activateButton}) {
    const selectSeverity = (header) => {
        if (header === "Cautions") {
            return "warning"
        } else if (header === "Warnings"){
            return "error"
        } else {
            return "info"
        }
    }
    const selectHeader = (header) => {
        if (header === "Cautions") {
            return "Caution"
        } else if (header === "Warnings"){
            return "Warning"
        } else {
            return "Info"
        }
    }

    const renderSteps = (itemSteps, item) => {
        let stepsSequences = itemSteps[item].sort((a, b) => { return a < b ? -1 : 1 })
        return stepsSequences.length > 0 ? stepsSequences : "Global Item"
    }

    const compileItems = (infoCollection, categories) => {
        let items = []
        if (infoCollection) {
            categories.map(category => {
                infoCollection[category].forEach(item => {
                    items.push(<li key={`caution-li-${item}`} style={{ marginBottom: '1em' }}>
                        {confirmedAlerts[item] !== true ?
                            <Alert severity={selectSeverity(category)} onClick={() => confirmAlerts({ ...confirmedAlerts, [item]: true })}>
                                <AlertTitle style={{ fontWeight: "bold" }}>{selectHeader(category)}</AlertTitle>
                                <strong>{item}</strong>
                                <br />
                                <span>{`Step: ${renderSteps(itemSteps, item)}`}</span>
                            </Alert>
                            :
                            <Alert severity="success">
                                <AlertTitle style={{ fontWeight: "bold" }}>{`${selectHeader(category)} Acknowledged`}</AlertTitle>
                                <strong>{item}</strong>
                                <br />
                                <span>{`Step: ${renderSteps(itemSteps, item)}`}</span>
                            </Alert>
                        }
                    </li>)
                })
                return category
            })
        }
        return items
    }

    const classes = useStyles();
    // getModalStyle is not a pure function, we roll the style only on the first render
    const [confirmedAlerts, confirmAlerts] = React.useState({})
    let categories = Object.keys(infoCollection)
    let items = compileItems(infoCollection, categories)
        return (
            <div className={classes.paper}>
                <ul>
                    {items}
                </ul>
                {(items.length && Object.values(confirmedAlerts).length === items.length) && !activatedButton ? 
                activateButton()
                : null}
            </div>
    );
}
